export class BfxFindFilterConditionData {
  public _operator: any | null = "";
  public _value: any | null = "";
  public _from: any | null = "";
  public _to: any | null = "";

  public get operator() {
    return this._operator;
  }

  public get value() {
    return this._value;
  }

  public get from() {
    return this._from;
  }

  public get to() {
    return this._to;
  }

  public set operator(operator) {
    this._operator = operator;
  }

  public set value(value) {
    this._value = value;
  }

  public set from(from) {
    this._from = from;
  }

  public set to(to) {
    this._to = to;
  }
}
